module.exports = __webpack_public_path__ + "static/media/system-zetonowy-level9.c46ae347.jpg";